// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uNECgBoDU2sV4gle98iW .ant-modal-content {

    border-radius: 10px;

    padding: 2rem
}

.b257WCKBvCU7tfmtTMdV {

    margin-bottom: 0.75rem;

    text-align: center;

    font-family: Noto Sans;

    font-size: 18px;

    font-weight: 700;

    --tw-text-opacity: 1;

    color: rgb(94 94 94 / var(--tw-text-opacity, 1))
}

.pNh1k_wzZm9tFPpGVEIg {

    margin-bottom: 1.5rem;

    text-align: center;

    font-family: Noto Sans;

    font-size: 13px;

    --tw-text-opacity: 1;

    color: rgb(141 141 141 / var(--tw-text-opacity, 1))
}

.QssziNCX7t1uKt0C87hZ {

    display: flex;

    align-items: center;

    justify-content: space-between;

    padding-top: 0.5rem;

    padding-bottom: 0.5rem;

    font-family: Noto Sans;

    font-size: 14px;

    --tw-text-opacity: 1;

    color: rgb(47 47 47 / var(--tw-text-opacity, 1))
}

.XFbV983BQ6QYb1CodZCE {

    margin: auto;

    margin-top: 1.5rem;

    display: flex;

    height: 42px;

    width: 100%;

    justify-content: center;

    border-radius: 5px;

    --tw-bg-opacity: 1;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1));

    --tw-text-opacity: 1;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

.XFbV983BQ6QYb1CodZCE:hover {

    --tw-bg-opacity: 1 !important;

    background-color: rgb(3 120 209 / var(--tw-bg-opacity, 1)) !important;

    --tw-text-opacity: 1 !important;

    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important
}
`, "",{"version":3,"sources":["webpack://./src/components/DowntimeModal/DowntimeModal.module.css"],"names":[],"mappings":"AACE;;IAAA,mBAAyB;;IAAzB;AAAyB;;AAIzB;;IAAA,sBAAsE;;IAAtE,kBAAsE;;IAAtE,sBAAsE;;IAAtE,eAAsE;;IAAtE,gBAAsE;;IAAtE,oBAAsE;;IAAtE;AAAsE;;AAItE;;IAAA,qBAA4D;;IAA5D,kBAA4D;;IAA5D,sBAA4D;;IAA5D,eAA4D;;IAA5D,oBAA4D;;IAA5D;AAA4D;;AAI5D;;IAAA,aAAkF;;IAAlF,mBAAkF;;IAAlF,8BAAkF;;IAAlF,mBAAkF;;IAAlF,sBAAkF;;IAAlF,sBAAkF;;IAAlF,eAAkF;;IAAlF,oBAAkF;;IAAlF;AAAkF;;AAIlF;;IAAA,YAAuB;;IAAvB,kBAAuB;;IAAvB,aAAuB;;IACvB,YAAyE;;IAAzE,WAAyE;;IAAzE,uBAAyE;;IAAzE,kBAAyE;;IAAzE,kBAAyE;;IAAzE,0DAAyE;;IAAzE,oBAAyE;;IAAzE;AADuB;;AAKvB;;IAAA,6BAA8B;;IAA9B,qEAA8B;;IAA9B,+BAA8B;;IAA9B;AAA8B","sourcesContent":[".modal :global(.ant-modal-content) {\n  @apply rounded-[10px] p-8;\n}\n\n.title {\n  @apply text-center font-inter font-bold text-[18px] text-gray-600 mb-3;\n}\n\n.description {\n  @apply text-center font-inter text-[13px] text-gray-400 mb-6;\n}\n\n.row {\n  @apply flex items-center justify-between font-inter text-[14px] text-gray-500 py-2;\n}\n\n.closeButton {\n  @apply flex m-auto mt-6;\n  @apply bg-primary text-white w-full h-[42px] justify-center rounded-[5px];\n}\n\n.closeButton:hover {\n  @apply !bg-primary !text-white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `uNECgBoDU2sV4gle98iW`,
	"title": `b257WCKBvCU7tfmtTMdV`,
	"description": `pNh1k_wzZm9tFPpGVEIg`,
	"row": `QssziNCX7t1uKt0C87hZ`,
	"closeButton": `XFbV983BQ6QYb1CodZCE`
};
export default ___CSS_LOADER_EXPORT___;
